import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteProjectSuggestionApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.DELETE_PROJECT_SUGGESTION,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteProjectSuggestionApi;